import * as ko from 'knockout';

import { BaseForm } from './base_form';
import * as trialsApi from '../api/trials';
import * as usersApi from '../api/users';
import { slugValidation, SlugGenerator } from '../ko_bindings/slug_validation';
import { I18nText, translate, asI18nText } from '../i18n_text';
import { canCopyAsTemplate, canCopyAsTrial } from '../permissions';
import { setGlobalError } from './base_edit';

let template = require('raw-loader!../../templates/trial_copy.html').default;

export function makeTrialCopyName(trialData: trialsApi.TrialData): I18nText {
  return asI18nText(translate(trialData.name_json) + ' (copy)');
}

class TrialCopyScreen extends BaseForm<{}> {
  private slugGenerator: SlugGenerator;
  private trialData: trialsApi.TrialData;

  copyAsTemplateAllowed = ko.observable(false);
  canChooseCopyTarget = ko.observable(false);

  nameJson = ko.observable<I18nText>().extend({
    i18nTextRequired: true,
    serverError: true,
  });
  nameSlug = ko.observable('').extend(slugValidation);
  template = ko.observable(false);

  globalError = ko.observable('');

  constructor(params: { id: string }) {
    super({});

    let mePromise = usersApi.me();
    let trialPromise = trialsApi.retrieve(params.id);
    let promise = Promise.all([mePromise, trialPromise]).then(([userData, trialData]) => {
      const source = {
        isTemplate: trialData.template,
        hasCrop: !!trialData.crop,
        isLibrary: trialData.edit_mode === 'library',
      };
      const copyAsTrial = canCopyAsTrial(source);
      const copyAsTemplate = canCopyAsTemplate(userData, source);
      // When only the template target is permitted, the checkbox stays visible but is
      // preselected and locked, so it's clear the copy will be a template.
      this.copyAsTemplateAllowed(copyAsTemplate);
      this.canChooseCopyTarget(copyAsTrial && copyAsTemplate);
      this.template(copyAsTemplate && !copyAsTrial);
      this.trialData = trialData;
      this.nameJson(makeTrialCopyName(trialData));
      this.slugGenerator = new SlugGenerator(this.nameJson, null, this.nameSlug, {
        canEdit: true,
        fillIfEmpty: true,
      });
      this.slugGenerator; // make compiler shut up
    });
    this.loadedAfter(promise);
  }

  save = () => {
    if (this.validateLocal(this)) {
      let data: trialsApi.TrialCopyData = {
        name_json: this.nameJson(),
        name_slug: this.nameSlug(),
        template: this.template(),
      };

      this.executeSaveRequest(trialsApi.copy(this.trialData.id, data)).then((validation) => {
        this.onRemoteValidation({}, this, validation);
        setGlobalError(this.globalError, validation);
      });
    }
  };
}

export let trialCopy = {
  name: 'trial-copy',
  viewModel: TrialCopyScreen,
  template: template,
};

ko.components.register(trialCopy.name, trialCopy);
